// extracted by mini-css-extract-plugin
export default {"Th":"styles_Th__DYgOu","sortable":"styles_sortable__g0syi","sortNone":"styles_sortNone__WgAnW"};